import { FormControl } from 'baseui/form-control'
import { Textarea } from 'baseui/textarea'
import { TYPE } from 'baseui/select'

import SDSelect from '@/shared/components/SDComponents/SDSelect/SDSelect'
import { HOPButtonGroup } from '@/shared/components/HOPComponents/HOPButtonGroup'

import usePodUpdater from './usePodUpdater'
import {
  ActionsRow,
  FixedSelectWrap,
  FullWidthButton,
  ModeRow,
  NotificationsWrapper,
  ProvidersRow
} from './styled-components'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

const PodUpdaterForm = () => {
  const { form, result, t } = usePodUpdater()

  return (
    <div>
      <ModeRow>
        <HOPButtonGroup
          onClickHandler={value => form.onModeChange(value)}
          options={[{ net: t('pod_updater.button.net') }, { abandon: t('pod_updater.button.abandon') }]}
          selectedValue={form.mode}
        />
      </ModeRow>

      <ProvidersRow>
        <FixedSelectWrap>
          <FormControl label={t('pod_updater.label_business_type')}>
            <SDSelect
              id="pod-updater-vertical"
              type={TYPE.select}
              options={form.businessTypeOptions}
              value={form.businessTypeOption ? [form.businessTypeOption] : []}
              onChange={params => form.onBusinessTypeChange(params?.value?.[0] || null)}
              disabled
            />
          </FormControl>
        </FixedSelectWrap>

        <FixedSelectWrap>
          <FormControl label={t('pod_updater.label_country')}>
            <SDSelect
              id="pod-updater-country"
              type={TYPE.select}
              options={form.countryOptions}
              value={form.countryOption ? [form.countryOption] : []}
              onChange={params => form.onCountryChange(params?.value?.[0] || null)}
              disabled
            />
          </FormControl>
        </FixedSelectWrap>

        <FixedSelectWrap>
          <FormControl label={t('pod_updater.label_provider')}>
            <SDSelect
              id="provider"
              type={TYPE.search}
              options={form.providers}
              value={form.provider ? [form.provider] : []}
              onChange={params => form.onProviderChange(params?.value?.[0] || null)}
            />
          </FormControl>
        </FixedSelectWrap>
      </ProvidersRow>

      <FormControl
        label={t('pod_updater.label_text_area')}
        caption={form.podsCount > 0 ? `${form.podsCount + t('pod_updater.caption_text_area')}` : undefined}
      >
        <Textarea
          value={form.podsText}
          onChange={e => form.onPodsTextChange(e.target.value)}
          placeholder={t('pod_updater.place_holder_text_area')}
          clearOnEscape
        />
      </FormControl>

      <ActionsRow>
        <FullWidthButton
          onClick={form.onSubmit}
          isLoading={form.isSubmitting}
          disabled={!form.isValid || form.isSubmitting}
        >
          {form.submitLabel}
        </FullWidthButton>
      </ActionsRow>

      <NotificationsWrapper>
        <SDNotification
          type="negative"
          hidden={!form.providersError}
          primaryText={String(form.providersError || '')}
        />

        <SDNotification
          type={result.error ? 'negative' : 'positive'}
          hidden={!result.message}
          primaryText={String(result.message || '')}
        />

        <SDNotification
          type="negative"
          hidden={!(result.error && !result.message)}
          primaryText={String(result.error || '')}
        />
      </NotificationsWrapper>
    </div>
  )
}

export default PodUpdaterForm
